const firebaseConfig = {
  apiKey: "AIzaSyA3MtX9LjmwCgPDrCSaijK9DfJoR-o3G-Q",
  authDomain: "ema-john-simple-auth-88e5a.firebaseapp.com",
  projectId: "ema-john-simple-auth-88e5a",
  storageBucket: "ema-john-simple-auth-88e5a.appspot.com",
  messagingSenderId: "657801306948",
  appId: "1:657801306948:web:1dad31ed6c775f9c302d11",
};

export default firebaseConfig;
